/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConnectionReason } from './connectionReason';
import type { NetworkMemberRef } from './networkMemberRef';
import type { NetworkPathSchemaKind } from './networkPathSchemaKind';
import type { NetworkPathSchemaStrength } from './networkPathSchemaStrength';
import type { SchoolReason } from './schoolReason';
import type { WorkReason } from './workReason';

/**
 * One active member's edge to a person.
 */
export interface NetworkPathSchema {
  member: NetworkMemberRef;
  kind: NetworkPathSchemaKind;
  strength?: NetworkPathSchemaStrength;
  reasons?: (ConnectionReason | WorkReason | SchoolReason)[];
}
